import {
	KuposCommonLoader,
	KuposDatePicker,
	KuposErrorSuccessModal,
	KuposInput,
	KuposModal,
	KuposSelectBox,
} from '../../../common';
import React, { useState } from 'react';

import ApiUrls from '../../../../services/apiUrls';
// import ApiUrls from '../../../services/apiUrls';
// import { AppData } from '../../../services';
import CommonService from '../../../../services/commonService';
import DateService from '../../../../services/dateService';
import getIcons from '../../functions/getIcons/getIcons';

const genderVal = [
	{ value: 'male', label: 'HOME.MALE' },
	{ value: 'female', label: 'HOME.FEMALE' },
];

function EditProfile(props) {
	const { profileData } = props;

	const [name, setName] = useState(profileData.name);
	const [nameError, setNameError] = useState(null);
	const [lastName, setLastName] = useState(profileData.last_name);
	const [lastNameError, setLastNameError] = useState(null);
	const [email, setEmail] = useState(profileData.email);
	const [emailError, setEmailError] = useState(null);
	const [phone, setPhone] = useState(profileData.phone);
	const [phoneError, setPhoneError] = useState(null);
	const [rut, setRut] = useState(profileData.identity_val);
	const [rutError, setRutError] = useState(null);
	const [dob, setDob] = useState(
		DateService.changeDateFormat(profileData.dob, 'yyyy-mm-dd', 'dd-mm-yyyy'),
	);
	const [dobError, setDobError] = useState(null);
	const [gender, setGender] = useState({
		label: profileData.gender == 'male' ? genderVal[0].label : genderVal[1].label,
		value: profileData.gender == 'male' ? genderVal[0].value : genderVal[1].value,
	});

	const [photo, setPhoto] = useState(null);
	const [showLoader, setShowLoader] = useState(null);
	const [showAlertModal, setShowAlertModal] = useState(null);
	const [uploadSuccess, setUploadSuccess] = useState(null);
	const [modalTitle, setModalTitle] = useState(null);
	const [modalBody, setModalBody] = useState(null);
	const [updateBody, setUpdateBody] = useState(null);
	const [updateSuccess, setUpdateSuccess] = useState(null);
	const [photoUrl, setPhotoUrl] = useState(null);
	const [passwordError, setPasswordError] = useState(null);
	const [password, setPassword] = useState(null);
	const [genderError, setGenderError] = useState(null);
	const [mobile, setMobile] = useState(null);
	const [mobileError, setMobileError] = useState(null);
	const [showSuccessModal, setShowSuccessModal] = useState(null);

	const onInputChange = (text, inp) => {
		if (inp == 'name') {
			// this.setState({
			//   nameError: null,
			//   name: text,
			// });
			setNameError(null);
			setName(text);
		} else if (inp == 'lastName') {
			// this.setState({
			//   lastNameError: null,
			//   lastName: text,
			// });
			setLastNameError(null);
			setLastName(text);
		} else if (inp == 'rut') {
			// this.setState({
			//   rutError: null,
			//   rut: text,
			// });
			setRutError(null);
			setRut(text);
		} else if (inp == 'phone') {
			text = CommonService.phoneNumberFormat(text);
			// this.setState({
			//   phoneError: null,
			//   phone: text,
			// });
			setPhoneError(null);
			setPhone(text);
		} else if (inp == 'password') {
			// this.setState({
			//   passwordError: null,
			//   password: text,
			// });
			setPasswordError(null);
			setPassword(text);
		} else if (inp == 'gender') {
			// this.setState({
			//   genderError: null,
			//   gender: text,
			// });
			setGenderError(null);
			setGender(text);
		} else if (inp == 'dob') {
			// this.setState({
			//   dobError: null,
			//   dob: text,
			// });
			setDobError(null);
			setDob(text);
		}
	};

	const onInputBlur = (text, inp) => {
		const { t } = props;
		if (!text) {
			if (inp == 'name') {
				// this.setState({
				//   nameError: {
				//     message: 'VALIDATIONS.VALID_NAME',
				//   },
				// });
				setNameError({
					message: 'VALIDATIONS.VALID_NAME',
				});
			} else if (inp == 'lastName') {
				// this.setState({
				//   lastNameError: {
				//     message: 'VALIDATIONS.VALID_SURNAME',
				//   },
				// });
				setLastNameError({
					message: 'VALIDATIONS.VALID_SURNAME',
				});
			} else if (inp == 'email') {
				// this.setState({
				//   emailError: {
				//     message: 'VALIDATIONS.VALID_EMAIL',
				//   },
				// });
				setEmailError({
					message: 'VALIDATIONS.VALID_EMAIL',
				});
			} else if (inp == 'phone') {
				// this.setState({
				//   phoneError: {
				//     message: 'VALIDATIONS.VALID_MOBILE',
				//   },
				// });
				setPhoneError({
					message: 'VALIDATIONS.VALID_MOBILE',
				});
			}
		} else if (inp == 'mobile') {
			if (mobile.toString().length != 9) {
				// this.setState({
				//   mobileError: {
				//     message: 'VALIDATIONS.VALID_MOBILE_LENGTH_9',
				//   },
				// })
				setMobileError({
					message: 'VALIDATIONS.VALID_MOBILE_LENGTH_9',
				});
			}
		} else if (inp == 'email') {
			if (!CommonService.isEMailValid(text)) {
				// this.setState({
				//   emailError: {
				//     message: 'VALIDATIONS.VALID_NAME',
				//   },
				// });
				setEmailError({
					message: 'VALIDATIONS.VALID_NAME',
				});
			}
		} else if (inp == 'name') {
		}
	};

	const isValid = () => {
		let errorCount = 0;
		if (!name) {
			// this.setState({
			//   nameError: {
			//     message: 'VALIDATIONS.VALID_NAME',
			//   },
			// });
			setNameError({
				message: 'VALIDATIONS.VALID_NAME',
			});
			errorCount++;
		}
		if (!phone) {
			// this.setState({
			//   phoneError: {
			//     message: 'VALIDATIONS.VALID_MOBILE',
			//   },
			// });
			setPhoneError({
				message: 'VALIDATIONS.VALID_MOBILE',
			});
			errorCount++;
		} else if (phone.toString().length != 9) {
			// this.setState({
			//   phoneError: {
			//     message: 'VALIDATIONS.VALID_MOBILE_LENGTH_9',
			//   },
			// });
			setPhoneError({
				message: 'VALIDATIONS.VALID_MOBILE_LENGTH_9',
			});
			errorCount++;
		}
		if (!lastName) {
			// this.setState({
			//   lastNameError: {
			//     message: 'VALIDATIONS.VALID_SURNAME',
			//   },
			// });
			setLastNameError({
				message: 'VALIDATIONS.VALID_SURNAME',
			});
			errorCount++;
		}

		if (errorCount <= 0) {
			return true;
		}
		return false;
	};

	const update = () => {
		if (!isValid()) {
			return;
		}
		// this.setState({
		//   showLoader: true,
		// });
		setShowLoader(true);

		let data = {
			name: name,
			last_name: lastName,
			dob: DateService.changeDateFormat(dob, 'dd-mm-yyyy', 'yyyy-mm-dd'),
			gender: gender ? gender.value : '',
		};

		if (CommonService.shouldPassOperatorId(props.operator)) {
			data['operator_id'] = CommonService.getOperatorId(props.operator)
		}
		if (!photo)
			props.updateProfile({ url: ApiUrls.updateProfile(), data: data }).then(
				res => {
					onResponse(res);
				},
				err => {
					onResponse(err);
				},
			);
		else updateWithUpload(data);
	};

	const onResponse = result => {
		// this.setState({
		//   showLoader: false,
		// });
		setShowLoader(false);
		if (!result) {
			return;
		}
		if (result.data && result.data.error) {
			//   this.refs.toast.show(result.data.error);
			// this.setState({
			//   showAlertModal: true,
			//   uploadSuccess: false,
			//   modalTitle: 'fracaso',
			//   modalBody: result.data.error,
			// });
			setShowAlertModal(true);
			setUploadSuccess(false);
			setModalTitle('fracaso');
			setModalBody(result.data.error);

			return;
		} else if (result.data && result.data.auth_token) {
			// this.setState({
			//   showSuccessModal: true,
			//   modalTitle: this.props.t('HOME.THANK_YOU'),
			//   updateBody: this.props.t('PROFILE.DETAILS_SAVED'),
			//   // button1Text:"VOLVER",
			//   // modalIcon:require('../../../assets/icons/success.png'),
			//   updateSuccess: true,
			// });
			setShowSuccessModal(true);
			setModalTitle(props.t('HOME.THANK_YOU'));
			setUpdateBody(props.t('PROFILE.DETAILS_SAVED'));
			setUpdateSuccess(true);

			CommonService.storeLoginDetails(result.data, props.setLoginData);
			// this.props.setLoginData(result.data);
			props.closeModal();
		} else {
			// this.setState({
			//   showSuccessModal: true,
			//   uploadSuccess: false,
			//   modalTitle: 'fracaso',
			//   modalBody: '¡Sus datos no se actualizaron!',
			// });
			setShowSuccessModal(true);
			setUploadSuccess(false);
			setModalTitle('fracaso');
			setModalBody('¡Sus datos no se actualizaron!');
		}
	};

	const updateWithUpload = data => {
		const document = {
			uri: photoUrl,
			type: photo.type,
			name: photo.name,
		};
		const form = new FormData();
		form.append('name', data.name);

		form.append('gender', data.gender);
		form.append('dob', data.dob);
		form.append('document', photo, photo.name);

		let options = {
			body: form,
			method: 'POST',
			headers: {
				// "Content-Type": "application/x-www-form-urlencoded",
				Authorization: global.token,
				XACCESS: global.xAccess,
			},
		};

		fetch(ApiUrls.updateProfile(), options)
			.then(response => {
				return response.json();
			})
			.catch(error => {
				// this.setState({
				//   showAlertModal: true,
				//   uploadSuccess: false,
				//   modalTitle: 'fracaso',
				//   showLoader: true,
				//   // modalBody:result.data.error,
				// });
				setShowAlertModal(true);
				setUploadSuccess(false);
				setModalTitle('fracaso');
				setShowLoader(true);
				return;
			})
			.then(responseData => {
				// this.setState({
				//   showLoader: false,
				// });
				setShowLoader(false);
				// console.log('Success', responseData);
				if (responseData) {
					if (responseData.error) {
						// this.setState({
						//   showAlertModal: true,
						//   uploadSuccess: false,
						//   modalTitle: 'fracaso',
						//   modalBody: responseData.data.error,
						// });
						setShowAlertModal(true);
						setUploadSuccess(false);
						setModalTitle('fracaso');
						setModalBody(responseData.data.error);
						return;
					} else if (responseData.auth_token) {
						// this.setState({
						//   showSuccessModal: true,
						//   modalTitle: this.props.t('HOME.THANK_YOU'),
						//   updateBody: this.props.t('PROFILE.DETAILS_SAVED'),
						//   // button1Text:"VOLVER",
						//   // modalIcon:require('../../../assets/icons/success.png'),
						//   updateSuccess: true,
						// });
						setShowSuccessModal(true);
						setModalTitle(props.t('HOME.THANK_YOU'));
						setUpdateBody(props.t('PROFILE.DETAILS_SAVED'));
						setUpdateSuccess(true);

						props.closeModal();
						CommonService.storeLoginDetails(responseData, props.setLoginData);
					}
				} else {
					// this.setState({
					//   showAlertModal: true,
					//   uploadSuccess: false,
					//   modalTitle: 'fracaso',
					//   // modalBody:result.data.error,
					// });
					setShowAlertModal(true);
					setUploadSuccess(false);
					setModalTitle('fracaso');
				}
			});
	};

	const onImageChange = e => {
		// this.setState({ photo: e.target.files[0] });
		setPhoto(e.target.files[0]);
		// this.setState({ photoUrl: URL.createObjectURL(e.target.files[0]) });
		setPhotoUrl(URL.createObjectURL(e.target.files[0]));
	};

	const onHide = () => {
		const { profileData } = props;
		// this.setState({
		//   name: profileData.name,
		//   nameError: null,
		//   lastName: profileData.last_name,
		//   lastNameError: null,
		//   email: profileData.email,
		//   emailError: null,
		//   phone: profileData.phone,
		//   phoneError: null,
		//   rut: profileData.identity_val,
		//   rutError: null,
		//   dob: DateService.changeDateFormat(profileData.dob, 'yyyy-mm-dd', 'dd-mm-yyyy'),
		//   dobError: null,
		//   photo: null,
		//   photoUrl: null,
		//   gender: {
		//     label: profileData.gender == 'male' ? gender[0].label : gender[1].label,
		//     value: profileData.gender == 'male' ? gender[0].value : gender[1].value,
		//   },
		// });
		setName(profileData.name);
		setNameError(null);
		setLastName(profileData.last_name);
		setLastNameError(null);
		setEmail(profileData.email);
		setEmailError(null);
		setPhone(profileData.phone);
		setPhoneError(null);
		setRut(profileData.identity_val);
		setRutError(null);
		setDob(DateService.changeDateFormat(profileData.dob, 'yyyy-mm-dd', 'dd-mm-yyyy'));
		setDobError(null);
		setPhoto(null);
		setPhotoUrl(null);
		setGender({
			label: profileData.gender == 'male' ? genderVal[0].label : genderVal[1].label,
			value: profileData.gender == 'male' ? genderVal[0].value : genderVal[1].value,
		});
		props.onHide();
	};

	console.log('Modify profile', gender);
	return (
		<div>
			<KuposModal
				ariaLabel="edit-modal"
				showModal={props.showEditProfile}
				onHide={onHide}
				size="lg"
			>
				<div className="my-account-edit-profile font10">
					<div className="internl-profile-edit-container">
						<div
							className="logged-in-capsule-menu"
							onClick={update}
							style={{
								backgroundColor:
									props.operator &&
										props.operator.color_codes &&
										props.operator.color_codes.account_tab_color
										? props.operator.color_codes.account_tab_color
										: '',
							}}
						>
							<span>{props.t('PROFILE.SAVE')}</span>
						</div>

						<div className="edit-profile-pic">
							{profileData && profileData.image_link ? (
								<div className="edit-dp">
									{' '}
									<img src={photo ? photoUrl : profileData.image_link} alt="DIS" />{' '}
								</div>
							) : (
								<div className="edit-dp">
									<img src={photo ? photoUrl : '/static/images/icons/home/icon-user-circle.png'} alt="" />
								</div>
							)}
							<div className="pencil">
								<img src="/static/images/edit-pencil.png" alt="" />
								<input
									type="file"
									accept="image/gif, image/jpeg, image/png, image/bmp"
									className="photo-file"
									onChange={onImageChange}
									name="myImage"
								/>
							</div>
						</div>

						<div className="edit-propfile-inps">
							<div className="edit-profile-grid">
								<div>
									<div>
										<span className="less-bold-text">{props.t('HOME.NAME')}</span>
									</div>
									<div className="icon-edit-element flex-row">
										<KuposInput
											type="text"
											value={name}
											onChange={text => onInputChange(text, 'name')}
											onBlur={text => onInputBlur(text, 'name')}
											error={nameError ? true : false}
											errorMessage={nameError ? nameError.message : ''}
											className="kupos-border"
										/>
									</div>
								</div>

								<div>
									<div>
										<span className="less-bold-text">{props.t('HOME.LAST_NAME')}</span>
									</div>
									<div className="icon-edit-element flex-row">
										<KuposInput
											type="text"
											value={lastName}
											onChange={text => onInputChange(text, 'lastName')}
											onBlur={text => onInputBlur(text, 'lastName')}
											error={lastNameError ? true : false}
											errorMessage={lastNameError ? lastNameError.message : ''}
											className="kupos-border"
										/>
									</div>
								</div>
							</div>

							<div className="edit-profile-grid">
								<div>
									<div>
										<span className="less-bold-text">RUT</span>
									</div>
									<div className="icon-edit-element flex-row">
										<KuposInput
											disabled={true}
											type="text"
											value={rut}
											onChange={text => onInputChange(text, 'rut')}
											onBlur={text => onInputBlur(text, 'rut')}
											error={rutError ? true : false}
											errorMessage={rutError ? rutError.message : ''}
											className="kupos-border"
										/>
									</div>
								</div>

								<div>
									<div>
										<span className="less-bold-text">{props.t('HOME.EMAIL_ID')}</span>
									</div>
									<div className="icon-edit-element flex-row">
										<KuposInput
											disabled={true}
											type="text"
											value={email}
											onChange={text => onInputChange(text, 'email')}
											onBlur={text => onInputBlur(text, 'email')}
											error={emailError ? true : false}
											errorMessage={emailError ? emailError.message : ''}
											className="kupos-border"
										/>
									</div>
								</div>
							</div>

							<div className="edit-profile-grid">
								<div>
									<div>
										<span className="less-bold-text">{props.t('HOME.PHONE_NUMBER')}</span>
									</div>
									<div className="icon-edit-element flex-row">
										<KuposInput
											disabled={true}
											type="text"
											value={phone}
											onChange={text => onInputChange(text, 'phone')}
											onBlur={text => onInputBlur(text, 'phone')}
											error={phoneError ? true : false}
											errorMessage={phoneError ? phoneError.message : ''}
											className="kupos-border"
											// iconRight={'/static/images/icon_check_square.png'}
											iconRight={getIcons('tick', props.operator)}
										/>
									</div>
								</div>

								<div>
									<div>
										<span className="less-bold-text">{props.t('PROFILE.GENDER')}</span>
									</div>
									<div className="icon-edit-element flex-row">
										<KuposSelectBox
											selectedOption={gender}
											options={genderVal}
											readonly={true}
											placeholder={'Opcional'}
											onChange={val => onInputChange(val, 'gender')}
											hideArrow={true}
											iconRight={gender ? getIcons('tick', props.operator) : null}
											height={40}
											error={genderError ? true : false}
											errorMessage={genderError ? genderError.message : ''}
											t={props.t}
											optionBgColor={
												props.operator &&
												props.operator.color_codes &&
												props.operator.color_codes.account_text_color &&
												props.operator.color_codes.account_text_color
											}
											optionTextColor={
												props.operator &&
												props.operator.color_codes &&
												props.operator.color_codes.secondary_text_color &&
												props.operator.color_codes.secondary_text_color
											}
										/>
									</div>
								</div>
							</div>

							<div className="edit-profile-grid">
								<div>
									<div>
										<span className="less-bold-text">{props.t('PROFILE.DATE_OF_BIRTH')}</span>
									</div>
									<div className="icon-edit-element flex-row">
										<KuposDatePicker
											canChangeYear={true}
											placeholder={'Opcional'}
											selectedDate={dob}
											onDateChange={text => onInputChange(text, 'dob')}
											error={dobError ? true : false}
											errorMessage={dobError ? dobError.message : ''}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					{showLoader ? (
						<div className="full-size-loader">
							<div>
								<KuposCommonLoader />
							</div>
						</div>
					) : null}
				</div>
			</KuposModal>
			<KuposErrorSuccessModal
				showModal={showAlertModal}
				// title={'¡Lo sentimos!'}
				subTitle={'Los cambios no pudieron ser realizados. Por favor intenta nuevamente.'}
				success={uploadSuccess}
				onButtonClick={() => {
					// this.setState({
					//   showAlertModal: false,
					//   modalTitle: null,
					//   modalBody: null,
					//   uploadSuccess: null,
					// })
					setShowAlertModal(false);
					setModalTitle(null);
					setModalBody(null);
					setUploadSuccess(null);
				}}
			/>
			<KuposErrorSuccessModal
				showModal={showSuccessModal}
				subTitle={updateBody}
				success={updateSuccess}
				onButtonClick={() => {
					// this.setState({
					//   showSuccessModal: false,
					//   modalTitle: null,
					//   updateBody: null,
					//   updateSuccess: null,
					// });
					setShowSuccessModal(false);
					setModalTitle(null);
					setUpdateBody(null);
					setUpdateSuccess(null);
				}}
				t={props.t}
				operator={props.operator}
			/>
		</div>
	);
}

export default EditProfile;

// export default class EditProfile extends Component {
//   static propTypes = {
//     showEditProfile: PropTypes.bool,
//     onHide: PropTypes.func,
//     profileData: PropTypes.object,
//     updateProfile: PropTypes.func,
//     setLoginData: PropTypes.func,
//     showLoader: PropTypes.bool,
//     closeModal: PropTypes.func,
//     t: PropTypes.func,
//   };

//   constructor(props) {
//     super(props);
//     const { profileData } = this.props;
//     this.state = {
//       name: profileData.name,
//       nameError: null,
//       lastName: profileData.last_name,
//       lastNameError: null,
//       email: profileData.email,
//       emailError: null,
//       phone: profileData.phone,
//       phoneError: null,
//       rut: profileData.identity_val,
//       rutError: null,
//       dob: DateService.changeDateFormat(profileData.dob, 'yyyy-mm-dd', 'dd-mm-yyyy'),
//       dobError: null,
//   gender: {
//     label: profileData.gender == 'male' ? gender[0].label : gender[1].label,
//     value: profileData.gender == 'male' ? gender[0].value : gender[1].value,
//   },
//   // gender:gender.find(
//   //   (it) => it.value == profileData.gender
//   // ),
// };
//   }

//   onInputChange = (text, inp) => {
//     if (inp == 'name') {
//       this.setState({
//         nameError: null,
//         name: text,
//       });
//     } else if (inp == 'lastName') {
//       this.setState({
//         lastNameError: null,
//         lastName: text,
//       });
//     } else if (inp == 'rut') {
//       this.setState({
//         rutError: null,
//         rut: text,
//       });
//     } else if (inp == 'phone') {
//       text = CommonService.phoneNumberFormat(text);
//       this.setState({
//         phoneError: null,
//         phone: text,
//       });
//     } else if (inp == 'password') {
//       this.setState({
//         passwordError: null,
//         password: text,
//       });
//     } else if (inp == 'gender') {
//       this.setState({
//         genderError: null,
//         gender: text,
//       });
//     } else if (inp == 'dob') {
//       this.setState({
//         dobError: null,
//         dob: text,
//       });
//     }
//   };
//   onInputBlur = (text, inp) => {
//     const { t } = this.props;
//     if (!text) {
//       if (inp == 'name') {
//         this.setState({
//           nameError: {
//             message: 'VALIDATIONS.VALID_NAME',
//           },
//         });
//       } else if (inp == 'lastName') {
//         this.setState({
//           lastNameError: {
//             message: 'VALIDATIONS.VALID_SURNAME',
//           },
//         });
//       } else if (inp == 'email') {
//         this.setState({
//           emailError: {
//             message: 'VALIDATIONS.VALID_EMAIL',
//           },
//         });
//       } else if (inp == 'phone') {
//         this.setState({
//           phoneError: {
//             message: 'VALIDATIONS.VALID_MOBILE',
//           },
//         });
//       }
//       //  else if (inp == 'rut') {
//       //   this.setState({
//       //     rutError: {
//       //       message: 'VALIDATIONS.VALID_RUT',
//       //     },
//       //   });
//       // }
//     } else if (inp == 'mobile') {
//       if (this.state.mobile.toString().length != 9) {
//         this.setState({
//           mobileError: {
//             message: 'VALIDATIONS.VALID_MOBILE_LENGTH_9',
//           },
//         });
//       }
//     } else if (inp == 'email') {
//       if (!CommonService.isEMailValid(text)) {
//         this.setState({
//           emailError: {
//             message: 'VALIDATIONS.VALID_NAME',
//           },
//         });
//       }
//     } else if (inp == 'name') {
//       // this.setState({
//       //   nameError: {
//       //     message: 'VALIDATIONS.VALID_NAME_LENGTH',
//       //   },
//       // });
//     }
//     // else if (inp == 'rut') {
//     //   if(!CommonService.isRutValid(text))
//     //     this.setState({
//     //       rutError: {
//     //         message: t('VALIDATIONS.VALID_RUT'),
//     //       },
//     //     });
//     //   this.setState({
//     //     rut:CommonService.formatRut(text)
//     //   })
//     // }
//   };

//   isValid = () => {
//     let errorCount = 0;
//     if (!this.state.name) {
//       this.setState({
//         nameError: {
//           message: 'VALIDATIONS.VALID_NAME',
//         },
//       });
//       errorCount++;
//       // }else if (this.state.name.length < 4) {
//       //   this.setState({
//       //     nameError: {
//       //       message: 'VALIDATIONS.VALID_NAME_LENGTH',
//       //     },
//       //   });
//       //   errorCount++;
//     }
//     if (!this.state.phone) {
//       this.setState({
//         phoneError: {
//           message: 'VALIDATIONS.VALID_MOBILE',
//         },
//       });
//       errorCount++;
//     } else if (this.state.phone.toString().length != 9) {
//       this.setState({
//         phoneError: {
//           message: 'VALIDATIONS.VALID_MOBILE_LENGTH_9',
//         },
//       });
//       errorCount++;
//     }
//     if (!this.state.lastName) {
//       this.setState({
//         lastNameError: {
//           message: 'VALIDATIONS.VALID_SURNAME',
//         },
//       });
//       errorCount++;
//     }
//     // if (!this.state.gender) {
//     //   this.setState({
//     //     genderError: {
//     //       message: 'VALIDATIONS.VALID_NAME',
//     //     },
//     //   });
//     //   errorCount++;
//     // }
//     // if (!this.state.dob) {
//     //   this.setState({
//     //     dobError: {
//     //       message: 'VALIDATIONS.VALID_NAME',
//     //     },
//     //   });
//     //   errorCount++;
//     // }
//     // if (!this.state.password) {
//     // this.setState({
//     //   passwordError: {
//     //     message: 'Password',
//     //   },
//     // });
//     // errorCount++;
//     // }
//     if (errorCount <= 0) {
//       return true;
//     }
//     return false;
//   };

//   update = () => {
//     if (!this.isValid()) {
//       return;
//     }
//     this.setState({
//       showLoader: true,
//     });

//     let data = {
//       name: this.state.name,
//       last_name: this.state.lastName,
//       // phone: this.state.mobile,
//       // identity_type: this.state.idCardType,
//       // identity_val: this.state.rut,
//       dob: DateService.changeDateFormat(this.state.dob, 'dd-mm-yyyy', 'yyyy-mm-dd'),
//       gender: this.state.gender ? this.state.gender.value : '',
//     };
//     if (!this.state.photo)
//       this.props.updateProfile({ url: ApiUrls.updateProfile(), data: data }).then(
//         res => {
//           this.onResponse(res);
//         },
//         err => {
//           this.onResponse(err);
//         },
//       );
//     else this.updateWithUpload(data);
//   };

//   onResponse = result => {
//     this.setState({
//       showLoader: false,
//     });
//     if (!result) {
//       return;
//     }
//     if (result.data && result.data.error) {
//       //   this.refs.toast.show(result.data.error);
//       this.setState({
//         showAlertModal: true,
//         uploadSuccess: false,
//         modalTitle: 'fracaso',
//         modalBody: result.data.error,
//       });
//       return;
//     } else if (result.data && result.data.auth_token) {
//       this.setState({
//         showSuccessModal: true,
//         modalTitle: this.props.t('HOME.THANK_YOU'),
//         updateBody: this.props.t('PROFILE.DETAILS_SAVED'),
//         // button1Text:"VOLVER",
//         // modalIcon:require('../../../assets/icons/success.png'),
//         updateSuccess: true,
//       });

//       CommonService.storeLoginDetails(result.data, this.props.setLoginData);
//       // this.props.setLoginData(result.data);
//       this.props.closeModal();
//     } else {
//       this.setState({
//         showSuccessModal: true,
//         uploadSuccess: false,
//         modalTitle: 'fracaso',
//         modalBody: '¡Sus datos no se actualizaron!',
//       });
//     }
//   };

//   updateWithUpload = data => {
//     const document = {
//       uri: this.state.photoUrl,
//       type: this.state.photo.type,
//       name: this.state.photo.name,
//     };
//     const form = new FormData();
//     form.append('name', data.name);
//     // form.append('identity_val', data.identity_val);
//     form.append('gender', data.gender);
//     form.append('dob', data.dob);
//     form.append('document', this.state.photo, this.state.photo.name);
//     // for (let d in data) {
//     //   form.append(d, data[d]);
//     // }

//     let options = {
//       body: form,
//       method: 'POST',
//       headers: {
//         // "Content-Type": "application/x-www-form-urlencoded",
//         Authorization: global.token,
//         XACCESS: global.xAccess,
//       },
//     };

//     fetch(ApiUrls.updateProfile(), options)
//       .then(response => {
//         return response.json();
//       })
//       .catch(error => {
//         this.setState({
//           showAlertModal: true,
//           uploadSuccess: false,
//           modalTitle: 'fracaso',
//           showLoader: true,
//           // modalBody:result.data.error,
//         });
//         return;
//       })
//       .then(responseData => {
//         this.setState({
//           showLoader: false,
//         });
//         // console.log('Success', responseData);
//         if (responseData) {
//           if (responseData.error) {
//             this.setState({
//               showAlertModal: true,
//               uploadSuccess: false,
//               modalTitle: 'fracaso',
//               modalBody: responseData.data.error,
//             });
//             return;
//           } else if (responseData.auth_token) {
//             this.setState({
//               showSuccessModal: true,
//               modalTitle: this.props.t('HOME.THANK_YOU'),
//               updateBody: this.props.t('PROFILE.DETAILS_SAVED'),
//               // button1Text:"VOLVER",
//               // modalIcon:require('../../../assets/icons/success.png'),
//               updateSuccess: true,
//             });

//             this.props.closeModal();
//             CommonService.storeLoginDetails(responseData, this.props.setLoginData);
//           }
//         } else {
//           this.setState({
//             showAlertModal: true,
//             uploadSuccess: false,
//             modalTitle: 'fracaso',
//             // modalBody:result.data.error,
//           });
//         }
//       });
//   };

//   onImageChange = e => {
//     this.setState({ photo: e.target.files[0] });
//     this.setState({ photoUrl: URL.createObjectURL(e.target.files[0]) });
//   };

//   onHide = () => {
//     const { profileData } = this.props;
//     this.setState({
//       name: profileData.name,
//       nameError: null,
//       lastName: profileData.last_name,
//       lastNameError: null,
//       email: profileData.email,
//       emailError: null,
//       phone: profileData.phone,
//       phoneError: null,
//       rut: profileData.identity_val,
//       rutError: null,
//       dob: DateService.changeDateFormat(profileData.dob, 'yyyy-mm-dd', 'dd-mm-yyyy'),
//       dobError: null,
//       photo: null,
//       photoUrl: null,
//       gender: {
//         label: profileData.gender == 'male' ? gender[0].label : gender[1].label,
//         value: profileData.gender == 'male' ? gender[0].value : gender[1].value,
//       },
//       // gender:gender.find(
//       //   (it) => it.value == profileData.gender
//       // )
//     });
//     this.props.onHide();
//   };

//   render() {
//     const { profileData } = this.props;
//     console.log('Modify profile', this.state.gender);
//     return (
//       <div>
//         <KuposModal
//           ariaLabel="edit-modal"
//           showModal={this.props.showEditProfile}
//           onHide={this.onHide}
//           size="lg"
//         >
//           <div className="my-account-edit-profile font10">
//             <div className="internl-profile-edit-container">
//               <div className="logged-in-capsule-menu" onClick={this.update}>
//                 <span>{this.props.t('PROFILE.SAVE')}</span>
//               </div>

//               <div className="edit-profile-pic">
//                 {profileData && profileData.image_link ? (
//                   <div className="edit-dp">
//                     {' '}
//                     <img
//                       src={this.state.photo ? this.state.photoUrl : profileData.image_link}
//                       alt="DIS"
//                     />{' '}
//                   </div>
//                 ) : (
//                   <div className="edit-dp">
//                     <img
//                       src={
//                         this.state.photo
//                           ? this.state.photoUrl
//                           : '/static/images/icons/home/icon-user-circle.png'
//                       }
//                       alt=""
//                     />
//                   </div>
//                 )}
//                 <div className="pencil">
//                   <img src="/static/images/edit-pencil.png" alt="" />
//                   <input
//                     type="file"
//                     accept="image/gif, image/jpeg, image/png, image/bmp"
//                     className="photo-file"
//                     onChange={this.onImageChange}
//                     name="myImage"
//                   />
//                 </div>
//               </div>

//               <div className="edit-propfile-inps">
//                 <div className="edit-profile-grid">
//                   <div>
//                     <div>
//                       <span className="less-bold-text">{this.props.t('HOME.NAME')}</span>
//                     </div>
//                     <div className="icon-edit-element flex-row">
//                       <KuposInput
//                         type="text"
//                         value={this.state.name}
//                         onChange={text => this.onInputChange(text, 'name')}
//                         onBlur={text => this.onInputBlur(text, 'name')}
//                         error={this.state.nameError ? true : false}
//                         errorMessage={this.state.nameError ? this.state.nameError.message : ''}
//                         className="kupos-border"
//                       />
//                     </div>
//                   </div>

//                   <div>
//                     <div>
//                       <span className="less-bold-text">{this.props.t('HOME.LAST_NAME')}</span>
//                     </div>
//                     <div className="icon-edit-element flex-row">
//                       <KuposInput
//                         type="text"
//                         value={this.state.lastName}
//                         onChange={text => this.onInputChange(text, 'lastName')}
//                         onBlur={text => this.onInputBlur(text, 'lastName')}
//                         error={this.state.lastNameError ? true : false}
//                         errorMessage={
//                           this.state.lastNameError ? this.state.lastNameError.message : ''
//                         }
//                         className="kupos-border"
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="edit-profile-grid">
//                   <div>
//                     <div>
//                       <span className="less-bold-text">RUT</span>
//                     </div>
//                     <div className="icon-edit-element flex-row">
//                       <KuposInput
//                         disabled={true}
//                         type="text"
//                         value={this.state.rut}
//                         onChange={text => this.onInputChange(text, 'rut')}
//                         onBlur={text => this.onInputBlur(text, 'rut')}
//                         error={this.state.rutError ? true : false}
//                         errorMessage={this.state.rutError ? this.state.rutError.message : ''}
//                         className="kupos-border"
//                       />
//                     </div>
//                   </div>

//                   <div>
//                     <div>
//                       <span className="less-bold-text">{this.props.t('HOME.EMAIL_ID')}</span>
//                     </div>
//                     <div className="icon-edit-element flex-row">
//                       <KuposInput
//                         disabled={true}
//                         type="text"
//                         value={this.state.email}
//                         onChange={text => this.onInputChange(text, 'email')}
//                         onBlur={text => this.onInputBlur(text, 'email')}
//                         error={this.state.emailError ? true : false}
//                         errorMessage={this.state.emailError ? this.state.emailError.message : ''}
//                         className="kupos-border"
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="edit-profile-grid">
//                   <div>
//                     <div>
//                       <span className="less-bold-text">{this.props.t('HOME.PHONE_NUMBER')}</span>
//                     </div>
//                     <div className="icon-edit-element flex-row">
//                       <KuposInput
//                         disabled={true}
//                         type="text"
//                         value={this.state.phone}
//                         onChange={text => this.onInputChange(text, 'phone')}
//                         onBlur={text => this.onInputBlur(text, 'phone')}
//                         error={this.state.phoneError ? true : false}
//                         errorMessage={this.state.phoneError ? this.state.phoneError.message : ''}
//                         className="kupos-border"
//                         iconRight={'/static/images/icon_check_square.png'}
//                       />
//                     </div>
//                   </div>

//                   <div>
//                     <div>
//                       <span className="less-bold-text">{this.props.t('PROFILE.GENDER')}</span>
//                     </div>
//                     <div className="icon-edit-element flex-row">
//                       <KuposSelectBox
//                         selectedOption={this.state.gender}
//                         options={gender}
//                         readonly={true}
//                         placeholder={'Opcional'}
//                         onChange={val => this.onInputChange(val, 'gender')}
//                         hideArrow={true}
//                         iconRight={this.state.gender ? '/static/images/icon_check_square.png' : null}
//                         height={40}
//                         error={this.state.genderError ? true : false}
//                         errorMessage={this.state.genderError ? this.state.genderError.message : ''}
//                         t={this.props.t}
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="edit-profile-grid">
//                   <div>
//                     <div>
//                       <span className="less-bold-text">
//                         {this.props.t('PROFILE.DATE_OF_BIRTH')}
//                       </span>
//                     </div>
//                     <div className="icon-edit-element flex-row">
//                       <KuposDatePicker
//                         canChangeYear={true}
//                         placeholder={'Opcional'}
//                         selectedDate={this.state.dob}
//                         onDateChange={text => this.onInputChange(text, 'dob')}
//                         error={this.state.dobError ? true : false}
//                         errorMessage={this.state.dobError ? this.state.dobError.message : ''}
//                       />
//                     </div>
//                   </div>

//                   {/* <div>
//                     <div>
//                       <span className="less-bold-text">Contraseña</span>
//                     </div>
//                     <div className="icon-edit-element  iconised-input flex-row">
//                       <KuposInput
//                         type="password"
//                         value={'*********'}
//                         // value={this.state.password}
//                         onChange={text => this.onInputChange(text, 'password')}
//                         onBlur={text => this.onInputBlur(text, 'password')}
//                         disabled={true}
//                         // error={this.state.nameError ? true : false}
//                         // errorMessage={this.state.nameError ? this.state.nameError.message : ''}
//                         className="kupos-border"
//                       />
//                     </div>
//                   </div> */}
//                 </div>
//               </div>

//               {/* <div className="primary-text last-text">Cambiar contraseña</div> */}
//             </div>
//             {this.state.showLoader ? (
//               <div className="full-size-loader">
//                 <div>
//                   <KuposCommonLoader />
//                 </div>
//               </div>
//             ) : null}
//           </div>
//         </KuposModal>
//         <KuposErrorSuccessModal
//           showModal={this.state.showAlertModal}
//           // title={'¡Lo sentimos!'}
//           subTitle={'Los cambios no pudieron ser realizados. Por favor intenta nuevamente.'}
//           success={this.state.uploadSuccess}
//           onButtonClick={() =>
//             this.setState({
//               showAlertModal: false,
//               modalTitle: null,
//               modalBody: null,
//               uploadSuccess: null,
//             })
//           }
//         />
//         <KuposErrorSuccessModal
//           showModal={this.state.showSuccessModal}
//           subTitle={this.state.updateBody}
//           success={this.state.updateSuccess}
//           onButtonClick={() =>
//             this.setState({
//               showSuccessModal: false,
//               modalTitle: null,
//               updateBody: null,
//               updateSuccess: null,
//             })
//           }
//           t={this.props.t}
//         />
//       </div>
//     );
//   }
// }



// WEBPACK FOOTER //
// ./src/features/themes/my-account/EditProfile/EditProfile.js